<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Data Gaji</h2>

      <br />

      <div class="btn-bar">
        <router-link to="/transaksi/gaji/-1" class="btn-fill btn-width-auto">
          Tambah Gaji
        </router-link>
        <div class="btn-grid">
          <form @submit.prevent="filterData" v-if="showFilter">
            <input
              type="search"
              placeholder="Cari..."
              v-model="keyword"
              ref="cari"
              @blur="showFilter = false"
            />
          </form>
          <button
            type="button"
            class="btn-outline"
            v-if="!showFilter"
            @click="exportExcel"
            :disabled="loadingExcel"
          >
            Export Excel
          </button>
          <button
            type="button"
            class="btn-outline btn-search"
            @click="toggleFilter"
          >
            <close v-if="showFilter" />
            <search v-if="!showFilter" />
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Bulan</th>
              <th>Total Gaji Karyawan</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              @click="$router.push('/transaksi/gaji/' + item.id)"
            >
              <td>{{ bulanTahun(item.bulan_tahun) }}</td>
              <td>{{ item.jumlah_fix | number }}</td>
              <td>
                <span @click.stop="confirmHapus(item)" class="btn-hapus"
                  >Hapus</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
  
  <script>
import * as api from "../../api/Api";
import Search from "../icons/Search.vue";
import Close from "../icons/Close.vue";

export default {
  name: "Gaji",
  components: {
    Search,
    Close,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      keyword: "",
      tmpData: [],
      data: [],
      showFilter: false,
      bulan: [
        "",
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
    };
  },
  methods: {
    toggleFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter) {
        setTimeout(() => {
          this.$refs["cari"].focus();
        }, 150);
      }
    },
    loadData() {
      this.loading = true;
      api
        .get("/v4/gaji?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loading = false;
          this.data = r.data;
          this.tmpData = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    filterData() {
      if (this.keyword) {
        this.data = this.data.filter((k) => {
          return k.nama.toLowerCase().includes(this.keyword);
        });
      } else {
        return (this.data = this.tmpData);
      }
    },
    confirmHapus(item) {
      if (confirm("Hapus " + item.gaji + "?")) {
        api.post("/v4/gaji/remove", item).then((r) => {
          this.$toast("Berhasil dihapus");
          this.loadData();
        });
      }
    },
    exportExcel() {
      if (this.data.length <= 0) {
        this.$toast("Tidak ada data untuk didownload");
        return;
      }

      this.loadingExcel = true;
      api
        .get("/v1/gaji/export-excel?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loadingExcel = false;
          if (r.valid) {
            location.href = r.filename;
          }
        })
        .catch((e) => {
          this.loadingExcel = false;
        });
    },
    bulanTahun(item) {
      const bulantahun = item.split("-");

      return this.bulan[parseInt(bulantahun[0])] + " " + bulantahun[1];
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
  
  <style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 15px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    input {
      width: 100%;
    }
  }

  .btn-grid {
    display: grid;
    grid-template-columns: 1fr 50px;
    grid-column-gap: 10px;
    form {
      width: 300px;
      input {
        width: 100%;
      }
    }
    .btn-search {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .table-wrapper {
    margin-top: 15px;
    height: calc(100vh - 270px);
  }

  .modal {
    position: fixed;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    .modal-body {
      background: #fff;
      width: 800px;
      height: 500px;
      padding: 20px;
      margin-top: 100px;
      border-radius: 7px;
      overflow: auto;
      h3 {
        margin: 0;
      }
      a {
        color: var(--primary);
        text-decoration: none;
        &:hover {
          font-weight: bold;
        }
      }
      input {
        width: auto;
      }
      .button-bar {
        display: flex;
        justify-content: space-between;
        margin: 15px 0 10px;
      }

      table {
        tr.animate-flicker {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/transaksi/GajiKaryawan.vue